import React, { useEffect, useRef } from 'react';
import { waitFor } from '../../CodesThatsGottaGoSomewhereElse';
import { LFC } from '../../Legacy';
import { CommandDispatcher } from '../../concepts/commands/CommandDispatcher';
import { Button, Colors, Prompt } from '../../ui';
import { useResolve } from '../Container';
import { AccountModel } from '../account/AccountModel';
import { Copy, Flexer, Title } from '../dashboard/elements/LayoutElements';
import { Popup, PopupProps } from '../popups/Popup';
import { confettiScreen } from './OnboardingCommands';

export const boardWelcomePopup = () => ({ ui: BoardWelcomePopup, fade: false });

export const BoardWelcomePopup: LFC<PopupProps> = ({ dismiss }) => {

    const account = useResolve(AccountModel);
    const dispatch = useResolve(CommandDispatcher);
    const base = useRef<HTMLDivElement>();

    const pop = () => {
        if (!base.current) return;
        const { left, top, width, height } = base.current.getBoundingClientRect();

        for (let angle = 30; angle <= 150; angle += 30) {
            dispatch(confettiScreen, [
                (left + (width / 2)) / window.innerWidth,
                (top + (height / 2)) / window.innerHeight,
                angle
            ]);
        }
    };

    useEffect(() => void (waitFor(100).then(pop)), [base.current]);

    return <Prompt ignoreEnter onAction={dismiss}>
        <Popup ref={base} w="32" p="0" shadow="lg" style={{ overflow: 'hidden' }}>
            <Flexer flex="column" center gap="1" padding="2" background={Colors.positive}>
                <Flexer flex="column" gap=".5" style={{ textAlign: 'center' }}>
                    {!account.legacy && <>
                        <Title flush size="xl" color="white">Welcome to Metro Retro!</Title>
                        <Copy flush size="1.125" color="white">
                            We hope you enjoy using the app.
                            If you need any help, look for the purple buttons for help guides or to talk to us via the support chat!
                        </Copy>
                    </>}
                    {account.legacy && <>
                        <Title flush size="xl" color="white">Welcome to the new Metro Retro!</Title>
                        <Copy flush size="1.125" color="white">
                            Don't forget to share this new board with your team!
                            If you need any help, look for the purple buttons for help guides or talk to us on the support chat.
                        </Copy>
                    </>}
                </Flexer>
                <Popup.Actions style={{ color: 'white' }}>
                    <Button onAction={dismiss}>Finish</Button>
                </Popup.Actions>
            </Flexer>
        </Popup>
    </Prompt>;
};
